import React, { FunctionComponent } from 'react';
import DOMPurify from 'dompurify';
import FlashMessage from '../design/FlashMessage';
import BulletedList from '../design/BulletedList';

export const ErrorList: FunctionComponent<IProps> = ({ errors }) => {
  if (!errors || !errors.length) return;

  if (errors.length === 1) {
    // eslint-disable-next-line consistent-return
    return <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errors[0]) }} />;
  }

  // eslint-disable-next-line consistent-return
  return <BulletedList items={errors} />;
};

interface IProps {
  errors: string[];
  // eslint-disable-next-line react/no-unused-prop-types
  closable?: boolean;
}

const FormErrorDisplay: FunctionComponent<IProps> = ({ errors, closable = false }) => {
  if (!errors || !errors.length) {
    return null;
  }

  const errorCase = <ErrorList errors={errors} />;

  return (
    <div style={{ margin: 5 }}>
      <FlashMessage type="error" message={errorCase} closable={closable} />
    </div>
  );
};

export default FormErrorDisplay;
